import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'phonemask',
    standalone: false
})
export class MaskPhoneNumberPipe implements PipeTransform {
    transform(phrase: string) {    
      return phrase.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    }
}